/* eslint-disable no-undef */
const _fbq = (...args) => {
  if (typeof fbq !== 'function') {
    return;
  }

  fbq(...args);
};

const typeCheck = (name, value, type) => {
  if (typeof value === type) {
    return;
  }

  throw new Error(
    `FacebookSDK: Expect variable(${name}) to be type(${type}), but it's type(${typeof value}) with value(${JSON.stringify(
      value
    )})`
  );
};

export default {
  WeTransfer_Site_Landing_Page_Overlay_WT_Free_send_file_Conversion() {
    _fbq('track', 'AddToWishlist', { content_type: 'free' });
  },
  WeTransfer_Site_Landing_Page_Overlay_WT_plus_send_file_Conversion() {
    _fbq('track', 'AddToWishlist', { content_type: 'plus' });
  },
  WeTransfer_Plus_Homepage_Visit() {
    _fbq('track', 'ViewContent', { content_type: 'plus' });
  },
  Wetransfer_Signup_Visit() {
    _fbq('track', 'AddToCart');
  },
  Wetransfer_Plus_Complete_Order_Conv() {
    _fbq('track', 'InitiateCheckout');
  },
  WeTransfer_Plus_Confirmation_Page_Conversion(params) {
    typeCheck('params', params, 'object');

    const { currency, value } = params;

    typeCheck('currency', currency, 'string');
    typeCheck('value', value, 'number');

    _fbq('track', 'Purchase', {
      value,
      currency: currency.toUpperCase(),
    });
  },
  WeTransfer_Account_Cancel_Subscription_Click() {
    _fbq('track', 'Schedule');
  },
  WeTransfer_Account_Cancel_Subscription_Go_Ahead_Click() {
    _fbq('track', 'StartTrial');
  },
  WeTransfer_Account_Reactivate_Plus_Conversion() {
    _fbq('track', 'SubmitApplication');
  },
  WeTransfer_Reactivate_Plus_Go_Ahead_Conversion() {
    _fbq('track', 'FindLocation');
  },
};
